import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { UCSoundNames } from "../../../../assetsLoader/UCAssetsNames";
import { UCFreespinOutroScreen } from "../freespin/UCFreespinOutroScreen";

export class UCSuperFreespinOutroScreen extends UCFreespinOutroScreen {
    constructor(parentContainer: AbstractView) {
        super(parentContainer, `UCSuperFreespinOutroScreen`);
    }

    protected override getTextureName(): string {
        return `SFS_OUTRO`;
    }

    protected override getScreenCustomName(): string {
        return `Super Freespin Outro`;
    }

    protected getBackgroundMusicName(): string {
        return UCSoundNames.SUPER_FREESPIN_MUSIC;
    }

    protected override getOutroWinSoundName(): string {
        return UCSoundNames.SFS_OUTRO_WIN;
    }
}
